module.exports = __webpack_public_path__ + "img/paciente_hombre.ad456e2d.svg";